import React, { ChangeEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldType, GeneratedField } from 'src/pages/CompanyPage/_BLL/types';
import { getFieldNameCompany } from 'src/pages/CompanyPage/lib/getFieldNameCompany';
import { SelectDictionary } from 'src/shared/ui/_inputs/SelectDictionary';
import { StringInput } from 'src/shared/ui/_inputs/StringInput';
import s from './IntegerFloatField.module.scss';

interface Props extends GeneratedField {
	valueType: Extract<FieldType, 'Integer' | 'Currency' | 'Float' | 'Id' | 'YearAge' | 'AgeFloat' | 'FloatDetailed'>;
}

export const IntegerFloatField: React.FC<Props> = (props) => {
	const {
		valueType, //
		namePrefix,
		propertyName,
		internalName,
		measureUnits,
		validate,
	} = props;

	// * Form
	const { setValue, control } = useFormContext();

	const NAME = getFieldNameCompany({ namePrefix, propertyName, internalName });

	const textFieldOnChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, fieldName: string) => {
		if (event.target.value === '') {
			setValue(fieldName, null);
		} else if (valueType === 'Integer' || valueType === 'Currency' || valueType === 'Id' || valueType === 'YearAge') {
			if (event.target.value.match(/^[0-9,]+$/g)) {
				const value = event.target.value.replace(/,/g, '');
				setValue(fieldName, value);
			}
		} else if (valueType === 'Float' || valueType === 'AgeFloat' || valueType === 'FloatDetailed') {
			if (event.target.value.match(/^[0-9,]*\.?[0-9,]*$/g)) {
				const value = event.target.value.replace(/,/g, '');
				setValue(fieldName, value);
			}
		} else return;
	};

	const fakeValue = (value: string) => {
		if (valueType !== 'Id' && propertyName !== 'birthYear' && valueType !== 'FloatDetailed' && valueType !== 'AgeFloat' && valueType !== 'YearAge') {
			const fakeValue = value.replace(/,/g, '');
			return fakeValue.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
		}

		return value;
	};

	const isCurrency = valueType === 'Currency';

	// * Render
	return (
		<Controller
			name={`${NAME}.value`}
			control={control}
			rules={{ validate: validate }}
			render={({ field, fieldState }) => (
				<div>
					<div className={s.fieldWrapper}>
						{/* Hidden input */}
						<input
							{...field}
							className={s.formInput}
							value={field.value === null ? '' : field.value}
						/>

						<StringInput
							{...field}
							className={s.textField}
							value={field.value === null ? '' : fakeValue(field.value)}
							onChange={(e) => textFieldOnChangeHandler(e, field.name)}
							error={fieldState.error?.message}
							suffix={(!isCurrency && measureUnits) ?? undefined}
							size="middle"
						/>
					</div>
				</div>
			)}
		/>
	);
};
